/* eslint-disable */

import React, { CSSProperties, SVGAttributes, FunctionComponent } from 'react';
import { getIconColor } from './helper';

interface Props extends Omit<SVGAttributes<SVGElement>, 'color'> {
  size?: number;
  color?: string | string[];
}

const DEFAULT_STYLE: CSSProperties = {
  display: 'block',
};

const IconFanhui: FunctionComponent<Props> = ({ size, color, style: _style, ...rest }) => {
  const style = _style ? { ...DEFAULT_STYLE, ..._style } : DEFAULT_STYLE;

  return (
    <svg viewBox="0 0 1024 1024" width={size + 'px'} height={size + 'px'} style={style} {...rest}>
      <path
        d="M591.424 302.144c13.845333 13.845333 14.528 35.861333 2.069333 50.538667l-2.069333 2.24-154.624 154.624 154.624 154.624c13.845333 13.866667 14.528 35.882667 2.069333 50.56l-2.069333 2.24a37.333333 37.333333 0 0 1-50.56 2.069333l-2.24-2.069333-165.930667-165.930667a58.666667 58.666667 0 0 1-2.453333-80.362667l2.453333-2.602666 165.930667-165.930667a37.333333 37.333333 0 0 1 52.8 0z"
        fill={getIconColor(color, 0, '#000000')}
      />
      <path
        d="M512 42.666667c259.2 0 469.333333 210.133333 469.333333 469.333333s-210.133333 469.333333-469.333333 469.333333S42.666667 771.2 42.666667 512 252.8 42.666667 512 42.666667z m0 74.666666C294.037333 117.333333 117.333333 294.037333 117.333333 512S294.037333 906.666667 512 906.666667 906.666667 729.962667 906.666667 512 729.962667 117.333333 512 117.333333z"
        fill={getIconColor(color, 1, '#11111F')}
      />
    </svg>
  );
};

IconFanhui.defaultProps = {
  size: 18,
};

export default IconFanhui;
